import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import "./AdminProducts.css";

function AdminProducts() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [topPrice, setTopPrice] = useState("");
  const [tag, setTag] = useState("");
  const [collection, setCollection] = useState("CLASSIC");
  const [description, setDescription] = useState("");

  const [images, setImages] = useState({
    image1: null,
    image2: null,
    image3: null,
    image4: null,
  });

  const [previews, setPreviews] = useState({
    image1: null,
    image2: null,
    image3: null,
    image4: null,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");

    navigate("/admin/login");
  };

  const handleImageChange = (e, imageName) => {
    const file = e.target.files[0];

    if (!file) return;

    setImages((prev) => ({
      ...prev,
      [imageName]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [imageName]: URL.createObjectURL(file),
    }));
  };

  const removeImage = (imageName) => {
    setImages((prev) => ({
      ...prev,
      [imageName]: null,
    }));

    setPreviews((prev) => ({
      ...prev,
      [imageName]: null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const token = localStorage.getItem("adminToken");

      const formData = new FormData();

      formData.append("name", name);
      formData.append("price", price);

      if (topPrice.trim() !== "") {
        formData.append("topPrice", topPrice.trim());
      }

      formData.append("tag", tag);
      formData.append("collection", collection);
      formData.append("description", description);

      if (images.image1) {
        formData.append("image1", images.image1);
      }

      if (images.image2) {
        formData.append("image2", images.image2);
      }

      if (images.image3) {
        formData.append("image3", images.image3);
      }

      if (images.image4) {
        formData.append("image4", images.image4);
      }

      const response = await fetch(
        `${API_BASE_URL}/api/products`,
        {
          method: "POST",

          headers: {
            Authorization: `Bearer ${token}`,
          },

          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to add product"
        );
      }

      setMessage("Product added successfully.");

      setName("");
      setPrice("");
      setTopPrice("");
      setTag("");
      setCollection("CLASSIC");
      setDescription("");

      setImages({
        image1: null,
        image2: null,
        image3: null,
        image4: null,
      });

      setPreviews({
        image1: null,
        image2: null,
        image3: null,
        image4: null,
      });

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const imageFields = [
    {
      key: "image1",
      number: "01",
      label: "Primary Image",
      required: true,
    },
    {
      key: "image2",
      number: "02",
      label: "Second Image",
      required: false,
    },
    {
      key: "image3",
      number: "03",
      label: "Third Image",
      required: false,
    },
    {
      key: "image4",
      number: "04",
      label: "Fourth Image",
      required: false,
    },
  ];

  return (
    <main className="tv-admin-products">

      {/* SIDEBAR */}

      <aside className="tv-admin-sidebar">

        <div className="tv-admin-sidebar-brand">
          <img
            src="/images/logo.png"
            alt="Time Valley"
          />

          <span>ADMINISTRATION</span>
        </div>

        <nav className="tv-admin-sidebar-nav">

          <button
            onClick={() =>
              navigate("/admin/dashboard")
            }
          >
            <span>01</span>
            Dashboard
          </button>

          <button className="tv-admin-nav-active">
            <span>02</span>
            Products
          </button>

          <button
            onClick={() =>
              navigate("/admin/collections")
            }
          >
            <span>03</span>
            Collections
          </button>

          <button>
            <span>04</span>
            Orders
          </button>

          <button>
            <span>05</span>
            Customers
          </button>

        </nav>

        <div className="tv-admin-sidebar-bottom">

          <button
            onClick={handleLogout}
            className="tv-admin-logout"
          >
            <span>↗</span>
            Sign Out
          </button>

        </div>

      </aside>

      {/* MAIN */}

      <section className="tv-admin-products-main">

        <header className="tv-admin-products-header">

          <div>
            <span>TIME VALLEY WATCHES</span>

            <h1>
              Add New
              <br />
              <em>Watch.</em>
            </h1>

            <p>
              Create a new timepiece for your
              Time Valley collection.
            </p>
          </div>

          <button
            className="tv-admin-back-button"
            onClick={() =>
              navigate("/admin/dashboard")
            }
          >
            ← Dashboard
          </button>

        </header>

        {/* MESSAGES */}

        {message && (
          <div className="tv-admin-product-success">
            {message}
          </div>
        )}

        {error && (
          <div className="tv-admin-product-error">
            {error}
          </div>
        )}

        {/* FORM */}

        <form
          className="tv-admin-product-form"
          onSubmit={handleSubmit}
        >

          {/* BASIC INFORMATION */}

          <section className="tv-admin-product-section">

            <div className="tv-admin-product-section-heading">
              <span>01</span>

              <div>
                <small>PRODUCT INFORMATION</small>
                <h2>Watch Details</h2>
              </div>
            </div>

            <div className="tv-admin-product-fields">

              <div className="tv-admin-product-field full">

                <label>
                  Product Name
                </label>

                <input
                  type="text"
                  placeholder="e.g. Time Valley Classic"
                  value={name}
                  onChange={(e) =>
                    setName(e.target.value)
                  }
                  required
                />

              </div>

              {/* TOP / ORIGINAL PRICE */}

              <div className="tv-admin-product-field">

                <label>
                  Top / Original Price
                  <span
                    style={{
                      marginLeft: "6px",
                      fontSize: "10px",
                      opacity: 0.55,
                      fontWeight: "400",
                    }}
                  >
                    OPTIONAL
                  </span>
                </label>

                <input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 80000"
                  value={topPrice}
                  onChange={(e) =>
                    setTopPrice(e.target.value)
                  }
                />

              </div>

              {/* SALE PRICE */}

              <div className="tv-admin-product-field">

                <label>
                  Selling Price
                </label>

                <input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 30000"
                  value={price}
                  onChange={(e) =>
                    setPrice(e.target.value)
                  }
                  required
                />

              </div>

              <div className="tv-admin-product-field">

                <label>
                  Tag
                </label>

                <input
                  type="text"
                  placeholder="NEW / BEST SELLER / LIMITED"
                  value={tag}
                  onChange={(e) =>
                    setTag(e.target.value)
                  }
                />

              </div>

              <div className="tv-admin-product-field">

                <label>
                  Watch Collection
                </label>

                <select
                  value={collection}
                  onChange={(e) =>
                    setCollection(e.target.value)
                  }
                >
                  <option value="PREMIUM">
                    Premium Watches
                  </option>

                  <option value="CLASSIC">
                    Classic Watches
                  </option>

                  <option value="ESSENTIAL">
                    Essential Watches
                  </option>
                </select>

              </div>

              <div className="tv-admin-product-field full">

                <label>
                  Description
                </label>

                <textarea
                  rows="7"
                  placeholder="Write a refined description for this timepiece..."
                  value={description}
                  onChange={(e) =>
                    setDescription(e.target.value)
                  }
                />

              </div>

            </div>

          </section>

          {/* IMAGES */}

          <section className="tv-admin-product-section">

            <div className="tv-admin-product-section-heading">

              <span>02</span>

              <div>
                <small>PRODUCT IMAGERY</small>
                <h2>Watch Images</h2>
              </div>

            </div>

            <p className="tv-admin-image-note">
              Upload up to four images. The first image
              is required; the remaining images are optional.
            </p>

            <div className="tv-admin-image-grid">

              {imageFields.map((field) => (

                <div
                  className="tv-admin-image-upload"
                  key={field.key}
                >

                  <div className="tv-admin-image-upload-top">

                    <span>
                      {field.number}
                    </span>

                    <label>
                      {field.label}
                      {field.required && " *"}
                    </label>

                  </div>

                  {previews[field.key] ? (

                    <div className="tv-admin-image-preview">

                      <img
                        src={previews[field.key]}
                        alt={field.label}
                      />

                      <button
                        type="button"
                        onClick={() =>
                          removeImage(field.key)
                        }
                      >
                        Remove
                      </button>

                    </div>

                  ) : (

                    <label
                      className="tv-admin-upload-box"
                    >

                      <input
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/webp"
                        onChange={(e) =>
                          handleImageChange(
                            e,
                            field.key
                          )
                        }
                        required={field.required}
                      />

                      <span className="tv-admin-upload-plus">
                        +
                      </span>

                      <strong>
                        Upload Image
                      </strong>

                      <small>
                        JPG, PNG or WEBP
                      </small>

                    </label>

                  )}

                </div>

              ))}

            </div>

          </section>

          {/* SUBMIT */}

          <div className="tv-admin-product-submit">

            <button
              type="button"
              onClick={() =>
                navigate("/admin/dashboard")
              }
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
            >
              {loading
                ? "Adding Watch..."
                : "Add Watch"}

              {!loading && <span>→</span>}
            </button>

          </div>

        </form>

      </section>

    </main>
  );
}

export default AdminProducts;